import script from "./EscanerQR.vue?vue&type=script&setup=true&lang=js"
export * from "./EscanerQR.vue?vue&type=script&setup=true&lang=js"

import "./EscanerQR.vue?vue&type=style&index=0&id=1c88faa2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c88faa2"]])

export default __exports__